import { DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, computed, inject } from '@angular/core';
import { ButtonDirective, DialogCloseButtonComponent } from '@innersource/common-ui-components';
import { ChatAttachmentsService } from '../chat-attachments.service';
import { ChatAttachment } from '../chat.model';

/** Previews a chat file and offers its download. */
@Component({
  selector: 'app-chat-attachment-preview-dialog',
  imports: [ButtonDirective, DialogCloseButtonComponent],
  templateUrl: './chat-attachment-preview-dialog.component.html',
  styleUrl: './chat-attachment-preview-dialog.component.scss',
})
export class ChatAttachmentPreviewDialogComponent {
  /** Services. */
  private readonly attachments = inject(ChatAttachmentsService);

  /** State. */
  readonly file = inject<ChatAttachment>(DIALOG_DATA);

  /** Returns the authenticated image preview when it is ready. */
  readonly previewUrl = computed(() => this.attachments.previewUrl(this.file));

  /** Loads the image at its full available resolution. */
  constructor() {
    void this.attachments.loadPreview(this.file);
  }

  /** Downloads the original file. */
  download(): void {
    void this.attachments.download(this.file);
  }
}
